import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BreadCrumb/BreadCrumb.css";
import Container from "../Container/Index";

const BreadCrumbs = ({
  _parentClass,
  customBreadCrum,
  secondName,
  pageLink,
  firstName,
  useContainer = true,
}) => {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  // Build dynamic breadcrumb items
  const breadcrumbItems = pathParts.map((part, index) => {
    const pathTo = "/" + pathParts.slice(0, index + 1).join("/");
    const formattedName = part.replace(/-/g, " ");
    return {
      name: formattedName,
      path: index < pathParts.length - 1 ? pathTo : null,
    };
  });

  const BreadCrumbContent = (
    <div className={`pagebreadcumb mt-2 ${_parentClass}`}>
      {/* If more than 3 levels, show auto-generated breadcrumb */}
      {pathParts.length > 3 ? (
         <ul className="d-flex">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            {pageLink ? <Link to={pageLink}>{firstName}</Link> : <span>{firstName}</span>}
          </li>
          {secondName && <li>{secondName}</li>}
        </ul>
      ) : (
       
        <ul className="d-flex">
          <li>
            <Link to="/">Home</Link>
          </li>
          {breadcrumbItems.map((item, i) => (
            <li key={i}>
              {item.path ? <Link to={item.path}>{item.name}</Link> : <span>{item.name}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return useContainer ? (
    <Container containerClass={"float-end"}>{BreadCrumbContent}</Container>
  ) : (
    BreadCrumbContent
  );
};

export default BreadCrumbs;
